import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { catchError, finalize, of } from 'rxjs';
import { AdvertGenerateAdditionalImagesDto, AdvertGenerateStatusDto, AdvertGeneratorDto, AdvertKeyFeaturesDto, AdvertPlanningInsightsDto, MultiplePropertyListingDto, PropertyListingDto, ReportDocumentDto, RiskscapePropertyDetailsDataDto, RiskscapeStructureExtentsData } from '../../../../../services/property-matrixV2/models';
import { AdvertService, FileManagementService, PlanningReportService, PropertyListingService } from '../../../../../services/property-matrixV2/services';
import { FileManagementExtensionService } from '../../../../../shared/services/file-management-extension-service/file-management-extension.service';
import { ProvideLatLonDialogComponent } from '../../../../../shared/components/provide-lat-lon-dialog/provide-lat-lon-dialog.component';
import { NotificationService } from '../../../../../shared/services/notification-service/notification.service';
import { ReportingService } from '../../../../../../app/shared/services/reporting-service/reporting.service';
import { FileExtended } from '../../../../../shared/services/../interfaces/file-extended';

@Component({
  selector: 'app-advert-generate-developed',
  templateUrl: './advert-generate-developed.component.html',
  styleUrls: ['./advert-generate-developed.component.scss',
    '../../../../../../css/2-modules/_admin-portal.scss']
})
export class AdvertGenerateDevelopedComponent implements OnInit {

  @Input() selectedListing: PropertyListingDto | undefined;
  @Input() selectedListingGroup: MultiplePropertyListingDto | undefined;
  @Input() isMultiple: boolean | undefined;
  @Input() sectorType: string | undefined;
  @Output() booleanEvent = new EventEmitter<boolean>();
  @Output() stepCompleted = new EventEmitter<void>();

  listingType: string | undefined;
  doNotPublishPropertyUnderDevelopment: boolean | null | undefined = true;

  sections = [
    { key: 0, value: '', checked: true },
    { key: 1, value: 'Information for displaying on property card', checked: true },
    { key: 2, value: 'Status', checked: false },
    { key: 3, value: 'Planning Insights', checked: false },
    { key: 4, value: 'Key Features', checked: false },
    { key: 5, value: 'Property Report', checked: false },
    { key: 6, value: 'Property Images', checked: false },
    { key: 7, value: 'Lat-long Coordinates', checked: false },
  ];

  loading: boolean = false;
  canMoveToNextTab: boolean = false;
  AdvertGenerateDevelopedFormPropertyInfo: FormGroup | undefined;
  hideLatLonPanel: boolean = false;
  latitude: number | null | undefined = null;
  longitude: number | null | undefined = null;
  LatLongCoordinatesNew: string = "";
  files: FileExtended[] = [];
  propertyReportFileId: string = "";
  fileUrlPropertyReport: string | null | undefined = "";
  hidePropertyReportButtons: boolean = false;
  filePropertyReport: any;

  propertyImageFileId: string = "";
  filePropertyImage: any;
  hidePropertyImageButtons: boolean = false;
  filePropertyImageUrl: string | null | undefined = "";

  advertKeyFeaturesList: AdvertKeyFeaturesDto[] = [];
  advertPlanningList: AdvertPlanningInsightsDto[] = [];
  advertStatusList: AdvertGenerateStatusDto[] = [];
  advertStatusFilteredList: AdvertGenerateStatusDto[] = [];
  advertGenerateDevelopedDTO: AdvertGeneratorDto = {};
  advertAdditionalImagesFiles: AdvertGenerateAdditionalImagesDto[] = [];

  riskscapePropertyDetailsDto: RiskscapePropertyDetailsDataDto | undefined = {};
  riskscapeStructureExtentsDto: RiskscapeStructureExtentsData | undefined = {};
  size: number | undefined = 0;
  headingOneSizeTypeLocation: string | undefined = "";
  documents: ReportDocumentDto[] = [];
  documentsFiltered: ReportDocumentDto[] = [];
  lastPlanningLevelTwoReport: ReportDocumentDto = {};
  private readonly emptyGuid = "00000000-0000-0000-0000-000000000000";
  isSifReviewed: boolean = false;
  addendumsIncluded: boolean = false;
  isSifReviewedUploaded: boolean = false;
  isSifReviewedLocation: boolean = false;

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private advertService: AdvertService,
    private reportingService: ReportingService,
    private fileManagementService: FileManagementService,
    private propertyListingService: PropertyListingService,
    private planningReportService: PlanningReportService,
    private fileManagementExtensionService: FileManagementExtensionService,
  ) { }

  ngOnInit(): void {
    try {
      if (this.selectedListing == null) {
        this.notificationService.showErrorMessage("Error", "The listing is not found. Please contact your administrator.");
        return;
      }

      if (this.doNotPublishPropertyUnderDevelopment == null) {
        this.notificationService.showErrorMessage("Error", "The Checkbox publish property under developed, is not set. Please contact your administrator.");
        return;
      }
      this.prePopulateFields();
      this.getAdvertTypes();
      this.preparePropertyInfoForm();
      this.getAdvertPropertyDetailsForListing();
      this.doNotPublishPropertyUnderDevelopment = true;
    } catch (ex) {
      this.notificationService.showErrorMessage("Error", "Could not load the advert.");
    }
  }

  public collapseOrExpandSection(section: { checked: boolean; }) {
    section.checked = !section.checked;
  }

  private preparePropertyInfoForm(): void {
    this.AdvertGenerateDevelopedFormPropertyInfo = this.fb.group({
      price: ["", [Validators.required]],
      headingOneSizeTypeLocation: ["", [Validators.required]],
      headingTwoAdvertType: ["", [Validators.required]],
      shortDescriptionOfProperty: ["", [Validators.required,Validators.maxLength(255)]],
    });
  }

  private getCheckedStatus() {
    return this.advertStatusFilteredList.filter(status => status.isChecked);
  }

  public openLocationDialog(): void {
    try {
      const dialogRef = this.dialog.open(ProvideLatLonDialogComponent, {
        width: '300px',
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.latitude = result.latitude;
          this.longitude = result.longitude;
          this.LatLongCoordinatesNew = this.latitude + " " + this.longitude;
        }
      });
    } catch (ex) {
      this.notificationService.showErrorMessage("Error", 'Could not set coordinates.');
    }
  }

  public replacePropertyReport(): void {
    this.fileUrlPropertyReport = "";
    this.hidePropertyReportButtons = false;
  }

  public deletePropertyReport(): void {
    try {
      if (this.propertyReportFileId) {
        this.notificationService.showConfirmMessage('Confirm Deletion', 'Are you sure you want to remove this listing?').then((confirmed) => {
          if (confirmed) {
            this.fileManagementService.apiV1FileManagementDeleteFileFileIdDelete({ fileId: this.propertyReportFileId }).subscribe({
              next: () => {
                this.notificationService.showSuccessMessage('Success', 'Report removed successfully.');
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              },
              error: (_error: any) => {
                this.notificationService.showErrorMessage('Error', 'Could not remove report.');
              }
            });
          }
        });
      } else {
        this.notificationService.showErrorMessage("Error", "The file Id not found");
      }
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "The file Id not found");
    }
    finally {
      this.loading = false;
    }
  }

  public async setPropertyReportFile(event: { target: { files: any[]; }; }) {
    try {
      this.propertyReportFileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.filePropertyReport = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.fileUrlPropertyReport = event.target.result;
        this.hidePropertyReportButtons = true;
      }

      reader.readAsDataURL(this.filePropertyReport);
    }
    catch (error) {
      this.notificationService.showErrorMessage('Error', 'Could not upload Property Report file.');
    }
    finally {
      this.loading = false;
    }
  }

  public replacePropertyImage(): void {
    this.filePropertyImageUrl = "";
    this.hidePropertyImageButtons = false;
  }

  public deletePropertyImage(): void {
    try {
      if (this.propertyImageFileId) {
        this.notificationService.showConfirmMessage('Confirm Deletion', 'Are you sure you want to remove this property image?').then((confirmed) => {
          if (confirmed) {
            this.fileManagementService.apiV1FileManagementDeleteFileFileIdDelete({ fileId: this.propertyImageFileId }).subscribe({
              next: () => {
                this.notificationService.showSuccessMessage('Success', 'Property image removed successfully.');
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              },
              error: (_error: any) => {
                this.notificationService.showErrorMessage('Error', 'Could not remove property image.');
              }
            });
          }
        });
      } else {
        this.notificationService.showErrorMessage("Error", "The file Id not found");
      }
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "The file Id not found");
    }
    finally {
      this.loading = false;
    }
  }

  public async setPropertyImageFile(event: { target: { files: any[]; }; }) {
    try {
      this.propertyImageFileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.filePropertyImage = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.filePropertyImageUrl = event.target.result;
        this.hidePropertyImageButtons = true;
      }

      reader.readAsDataURL(this.filePropertyImage);
    }
    catch (error) {
      this.notificationService.showErrorMessage('Error', 'Could not upload Property Report file.');
    }
    finally {
      this.loading = false;
    }
  }

  public removeAdvertKeyFeature(index: number): void {
    const element = this.advertKeyFeaturesList[index];
    this.advertKeyFeaturesList.splice(index, 1);
  }

  public addNewKeyFeatureItem(): void {
    try {
      let advertKeyFeaturesDto: AdvertKeyFeaturesDto = {
        id: "00000000-0000-0000-0000-000000000000",
        description: "",
        isDeleted: false,
      };

      this.advertKeyFeaturesList.push(advertKeyFeaturesDto);
    }
    catch (error) {
      this.notificationService.showErrorMessage('Error', 'Error adding new key feature.');
    }
  }

  public removeAdvertPlanningInsights(index: number): void {
    const element = this.advertPlanningList[index];
    this.advertPlanningList.splice(index, 1);
  }

  public AdvertPlanningInsightsItem(): void {
    try {
      let advertKeyFeaturesDto: AdvertPlanningInsightsDto = {
        id: "00000000-0000-0000-0000-000000000000",
        description: "",
        isDeleted: false,
      };

      this.advertPlanningList.push(advertKeyFeaturesDto);
    }
    catch (error) {
      this.notificationService.showErrorMessage('Error', 'Error adding new planning insights.');
    }
  }

  private getAdvertTypes(): void {
    this.loading = true;
    this.advertService.apiV1AdvertGetStatusDtOsGet()
      .pipe(
        catchError((err) =>
          of(
            this.notificationService.showErrorMessage('Error', 'The sector type to filter the status is not defined and will not filter status.')
          )
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: AdvertGenerateStatusDto[] | void) => {
        if (result) {
          this.advertStatusList = result;
          if (this.sectorType) {
            this.advertStatusFilteredList = this.advertStatusList.filter(s => s.sectorType == this.sectorType)
          } else {
            this.notificationService.showWarningMessage('Warning', 'The sector type to filter the status is not defined and will not filter status.');
          }
        }
      });
  }

  public saveAdvertDevelopedData(): void {
    try {
      this.loading = true;
      this.saveData().then(result => {
        this.loading = false;
        if (result == true) {
          this.notificationService.showSuccessMessage("Saved", "Task successfully completed.");
        } else {
          this.notificationService.showErrorMessage("Error", "Could not save advert filters");
        }
      });
    }
    catch (ex) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Could not save advert because of errors.');
    }
    finally {
      this.loading = false;
    }
  }

  public completeAdvertDevelopedData(): void {
    try {
      if (!this.isSifReviewed && !this.addendumsIncluded) {
        this.notificationService.showErrorMessage('Error', 'Please tick both checkboxes before completing.');
        return;
      }
      if (!this.isSifReviewed) {
        this.notificationService.showErrorMessage('Error', 'Please tick the SIF reviewed checkbox before completing.');
        return;
      }
      if (!this.addendumsIncluded) {
        this.notificationService.showErrorMessage('Error', 'Please tick the addendums included checkbox before completing.');
        return;
      }

      this.loading = true;
      this.saveData().then(result => {
        this.loading = false;
        if (result == true) {
          this.notificationService.showSuccessMessage("Saved", "Saved advert filters successfully and task completed.");
          this.stepCompleted.emit();
        } else {
          this.loading = false;
          this.notificationService.showErrorMessage("Error", "Could not save advert filters");
        }
      });
    }
    catch (ex) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Could not save advert filters because of errors.');
    }
    finally {
      this.loading = false;
    }
  }

  private saveData(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        if (this.getCheckedStatus().length == 0) {
          this.notificationService.showErrorMessage("Error", "Please select status fields");
          console.error("Error", "Please select status fields");
          return;
        }
        if (this.advertKeyFeaturesList.length == 0) {
          this.notificationService.showErrorMessage("Error", "Could not save Key Feature fields. Make sure all has values to continue.");
          console.error("Error found on Key Feature fields. Make sure all has values to continue.");
          return;
        }

        if (this.advertPlanningList.length == 0) {
          this.notificationService.showErrorMessage("Error", "Could not save Planning Insights fields. Make sure all has values to continue.");
          console.error("Error found on Planning Insights fields. Make sure all has values to continue.");
          return;
        }

        if (this.AdvertGenerateDevelopedFormPropertyInfo?.valid == false) {
          this.notificationService.showErrorMessage("Error", "Could not save property Information fields. Make sure all has values to continue.");
          console.error("Error found on property Information fields. Make sure all has values to continue.");
          return;
        }

        if (this.propertyImageFileId.length == 0) {
          this.notificationService.showErrorMessage("Error", "Could not find Property Image found . Make sure all has values to continue.");
          console.error("Error found, There is no Property Image found . Make sure all has values to continue.");
          return;
        }

        if (this.propertyReportFileId.length == 0) {
          this.notificationService.showErrorMessage("Error", "Could not find Property Report found . Make sure all has values to continue.");
          console.error("Error found, There is no Property Report found . Make sure all has values to continue.");
          return;
        }

        const priceField = this.AdvertGenerateDevelopedFormPropertyInfo?.get('price')?.value ?? "";

        if (!this.LatLongCoordinatesNew) {
          this.notificationService.showErrorMessage("Error", "Could not find coordinates. Make sure all has values to continue.");
          console.error("Error found on property Information fields. Make sure all has values to continue.");
          return;
        }

        if (!this.latitude) {
          this.notificationService.showErrorMessage("Error", "Could not find coordinates. Make sure all has values to continue.");
          return;
        }

        this.advertGenerateDevelopedDTO = {
          coordinates: this.LatLongCoordinatesNew,
          advertGenerateAdditionalImages: this.advertAdditionalImagesFiles,
          advertGenerateStatusses: this.getCheckedStatus(),
          id: this.advertGenerateDevelopedDTO.id == null ? "00000000-0000-0000-0000-000000000000" : this.advertGenerateDevelopedDTO.id,
          isDeleted: false,
          advertKeyFeatures: this.advertKeyFeaturesList,
          advertPlanningInsights: this.advertPlanningList,
          latitude: this.latitude!.toString() ?? "",
          longitude: this.longitude!.toString() ?? "",
          propertyImageFileId: this.propertyImageFileId ?? "",
          propertyInfoAdvertType: this.AdvertGenerateDevelopedFormPropertyInfo?.get('headingTwoAdvertType')?.value ?? "",
          propertyInfoPrice: this.AdvertGenerateDevelopedFormPropertyInfo?.get('price')?.value ?? "",
          propertyInfoShortDescription: this.AdvertGenerateDevelopedFormPropertyInfo?.get('shortDescriptionOfProperty')?.value ?? "",
          propertyInfoSizeTypeLocation: this.AdvertGenerateDevelopedFormPropertyInfo?.get('headingOneSizeTypeLocation')?.value ?? "",
          propertyReportFileId: this.propertyReportFileId ?? "",
          publishPropertyAdvertUnderDevelopAbles: false,
          publishPropertyAdvertUnderDeveloped: true,
          propertyListingId: this.selectedListing?.id,
          sectorTypeDevelopedDevelopable: "Developed",
          isSifReviewed: this.isSifReviewed,
          addendumsIncluded: this.addendumsIncluded,
          isSifReviewedUploaded: this.isSifReviewedUploaded,
          isSifReviewedLocation: this.isSifReviewedLocation
        }
        this.loading = true;
        this.advertService.apiV1AdvertSaveAdvertGeneratorReportPost({
          body: this.advertGenerateDevelopedDTO
        })
          .pipe(
            catchError((err) =>
              of(
                this.notificationService.showErrorMessage("Error", "Could not save the advert details.")
              )
            ),
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe((result) => {
            this.loading = false;
            if (result === true) {
              this.getAdvertTypes();
              this.prePopulateFields();
            }

            resolve(true);
          })
      } catch (ex) {
        this.loading = false;
        this.notificationService.showErrorMessage("Error", 'Could not save Advert filters.');
        resolve(false);
        reject("Error caught on service call save Advert filters.");
      }
    });
  }

  public onDragOver(event: Event): void {
    event.preventDefault();
  }

  public onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) {
      const files = event.dataTransfer.files;
      this.addFiles(files);
    }
  }

  public onFileInput(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const files = element.files;
    if (files && files.length > 0) {
      this.addFiles(files);
      element.value = '';
    } else {
      this.notificationService.showErrorMessage('Error', 'Could not upload file.');
    }
  }


  public deleteAdditionalImageFile(fileId: string, index: number): void {
    this.loading = true;
    this.advertService.apiV1AdvertDeleteAdvertAdditionalImageWithIdDelete({ advertAdditionalImageId: fileId })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", 'Image could not be removed.'))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: void) => {
        this.loading = false;
        this.advertAdditionalImagesFiles.splice(index, 1);
        this.notificationService.showSuccessMessage('Success', 'Image removed successfully.');
      });
  }

  public async addFiles(files: FileList): Promise<void> {
    let index = 0;
    const uploadPromises: Promise<void>[] = [];
    let hasDuplicate = false;
    this.loading = true;

    Array.from(files).forEach((file: File) => {
      const fileExtended = file as FileExtended;
      if (!this.files.some(f => f.name === fileExtended.name)) {
        uploadPromises.push(this.uploadFile(fileExtended, index));
      } else {
        hasDuplicate = true;
      }
      index++;
    });

    try {
      if (uploadPromises.length > 0) {
        await Promise.all(uploadPromises);
        this.notificationService.showSuccessMessage(
          'Success',
          `${uploadPromises.length} image(s) uploaded successfully.`
        );
      }

      if (hasDuplicate) {
        this.notificationService.showWarningMessage(
          'Warning',
          'Some duplicate files were skipped.'
        );
      }

    } catch (error) {
      this.notificationService.showErrorMessage(
        'Error',
        'Some files failed to upload.'
      );
    } finally {
      this.loading = false;
    }
  }

  private async uploadFile(file: FileExtended, index: number): Promise<void> {
    try {
      const result = await this.fileManagementExtensionService.uploadFile(file);
      file.id = result;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.files.push(file);
        const document: AdvertGenerateAdditionalImagesDto = {
          id: result,
          description: file.name,
          isDeleted: false,
        };
        this.advertAdditionalImagesFiles.push(document);
      };
      reader.readAsDataURL(file);

    } catch (error) {
      throw error;
    }
  }


  public goToListingOverViewRoute(): void {
    this.router.navigate(['admin/listings/listing-overview'], {
      queryParams: {
        listingType: this.listingType
      }
    });
  }

  private prePopulateFields(): void {
    this.loading = true;
    this.advertService.apiV1AdvertGetAdvertReportDevelopedDataWithListingIdGet({ propertyListingId: this.selectedListing?.id })
      .pipe(
        catchError((err) =>
          of(
          )
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response: any | void) => {
        if (response.success && response.data) {
          this.loading = false;

          if (response.data) {
            this.advertGenerateDevelopedDTO = response.data;

            this.doNotPublishPropertyUnderDevelopment = this.advertGenerateDevelopedDTO.publishPropertyAdvertUnderDeveloped ?? false;
            this.latitude = Number(this.advertGenerateDevelopedDTO.latitude) ?? 0;
            this.longitude = Number(this.advertGenerateDevelopedDTO.longitude) ?? 0;
            this.LatLongCoordinatesNew = this.latitude + " " + this.longitude;

            if (this.advertGenerateDevelopedDTO.advertKeyFeatures) {
              this.advertKeyFeaturesList = this.advertGenerateDevelopedDTO.advertKeyFeatures;
            }

            if (this.advertGenerateDevelopedDTO.advertPlanningInsights) {
              this.advertPlanningList = this.advertGenerateDevelopedDTO.advertPlanningInsights;
            }

            this.isSifReviewed = this.advertGenerateDevelopedDTO.isSifReviewed ?? false;

            this.addendumsIncluded = this.advertGenerateDevelopedDTO.addendumsIncluded ?? false;

            if (this.advertGenerateDevelopedDTO.isSifReviewedUploaded) {
              this.isSifReviewedUploaded = this.advertGenerateDevelopedDTO.isSifReviewedUploaded ?? false;
            }

            if (this.advertGenerateDevelopedDTO.isSifReviewedLocation) {
              this.isSifReviewedLocation = this.advertGenerateDevelopedDTO.isSifReviewedLocation ?? false;
            }

            this.propertyReportFileId = this.advertGenerateDevelopedDTO.propertyReportFileId ?? "";
            if (this.propertyReportFileId) {
              this.hidePropertyReportButtons = true;
            }

            this.propertyImageFileId = this.advertGenerateDevelopedDTO.propertyImageFileId ?? "";
            if (this.propertyImageFileId) {
              this.hidePropertyImageButtons = true;
            }

            if (this.advertGenerateDevelopedDTO.propertyInfoPrice) {
              this.AdvertGenerateDevelopedFormPropertyInfo?.setValue(
                {
                  'price': this.advertGenerateDevelopedDTO.propertyInfoPrice,
                  'headingOneSizeTypeLocation': this.advertGenerateDevelopedDTO.propertyInfoSizeTypeLocation,
                  'headingTwoAdvertType': this.advertGenerateDevelopedDTO.propertyInfoAdvertType,
                  'shortDescriptionOfProperty': this.advertGenerateDevelopedDTO.propertyInfoShortDescription
                });
            }

            if (this.advertGenerateDevelopedDTO.advertGenerateStatusses) {
              this.prePopulateStatus(this.advertGenerateDevelopedDTO.advertGenerateStatusses);
            }

            if (this.advertGenerateDevelopedDTO.advertGenerateAdditionalImages) {
              this.prePopulateAdditionalImages(this.advertGenerateDevelopedDTO.advertGenerateAdditionalImages);
            }

            if (this.advertGenerateDevelopedDTO.propertyReportFileId) {
              this.propertyReportFileId = this.advertGenerateDevelopedDTO.propertyReportFileId;
              this.reportingService.getFileUrl(this.propertyReportFileId)
                .then(url => this.fileUrlPropertyReport = url);
            }
            else {
              this.checkPropertyReport();
            }

            if (this.advertGenerateDevelopedDTO.propertyImageFileId) {
              this.propertyImageFileId = this.advertGenerateDevelopedDTO.propertyImageFileId;
              this.reportingService.getFileUrl(this.propertyImageFileId)
                .then(url => this.filePropertyImageUrl = url);
            }
            else {
              this.checkPropertyImages();
            }

          }
        } else {
          this.loading = false;
          this.notificationService.showErrorMessage('Error', 'Could not load Advert pre-populated data.');
        }
      })
  }

  private prePopulateStatus(statusList: AdvertGenerateStatusDto[]) {
    for (let index = 0; index < this.advertStatusFilteredList.length; index++) {
      const filterStatus = this.advertStatusFilteredList[index];
      for (let index = 0; index < statusList.length; index++) {
        const Status = statusList[index];
        if (filterStatus.description == Status.description) {
          filterStatus.isChecked = true;
        }
      }
    }
  }

  private prePopulateAdditionalImages(additionalImageList: AdvertGenerateAdditionalImagesDto[]): void {
    for (let index = 0; index < additionalImageList.length; index++) {
      const additionalImage = additionalImageList[index];
    };
    this.addAdditionalImages(additionalImageList);
  }

  private addAdditionalImages(additionalImageList: AdvertGenerateAdditionalImagesDto[]): void {
    this.advertAdditionalImagesFiles = additionalImageList;
  }

  private getAdvertPropertyDetailsForListing(): void {
    this.loading = true;

    if (this.selectedListing.propertyDetail?.riskscape) {
      this.headingOneSizeTypeLocation = this.selectedListing.propertyDetail?.riskscape.riskscapePropertyInfo.propertyType + " " + this.selectedListing.propertyDetail?.propertyAddress;

      this.AdvertGenerateDevelopedFormPropertyInfo?.setValue({
        'price': this.selectedListing?.propertyDetail?.askingPrice,
        'headingOneSizeTypeLocation': this.headingOneSizeTypeLocation,
        'headingTwoAdvertType': "Possible Development/Highest Best/On Offer",
        'shortDescriptionOfProperty': this.selectedListing.propertyDetail?.riskscape.riskscapePropertyInfo.fullAddress
      });
      this.latitude = this.selectedListing.propertyDetail?.latitude;
      this.longitude = this.selectedListing.propertyDetail?.longitude;
      if (this.latitude && this.longitude) {
        this.LatLongCoordinatesNew = this.latitude + " " + this.longitude;
      }
    }
  }

  private checkPropertyReport(): void {
    this.loading = true;

    this.planningReportService.apiV1PlanningReportGetReportDocumentsGet({ planningReportId: this.selectedListing?.planningReportId })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Error getting the Planning report."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: ReportDocumentDto[] | void) => {
        if (result && result.length > 0) {
          this.documents = [];
          this.documents = result;
          this.documentsFiltered = this.documents.filter(d => d.reportType == "LevelOneSingleReport" || d.reportType == "LevelTwoSingleReport");
          if (this.documentsFiltered.length > 1) {
            //Why is this here
            //   this.advertAdditionalImagesFiles = this.documentsFiltered;
            this.lastPlanningLevelTwoReport = this.documentsFiltered[0];
            this.fileUrlPropertyReport = this.lastPlanningLevelTwoReport.downloadUrl?.split('?')[0] ?? this.lastPlanningLevelTwoReport.downloadUrl;
            this.propertyReportFileId = this.lastPlanningLevelTwoReport.id;
            this.hidePropertyReportButtons = true;
          } else {
            this.lastPlanningLevelTwoReport = this.documentsFiltered[0];
            this.fileUrlPropertyReport = this.lastPlanningLevelTwoReport.downloadUrl?.split('?')[0] ?? this.lastPlanningLevelTwoReport.downloadUrl;
            this.propertyReportFileId = this.lastPlanningLevelTwoReport.id;
            this.hidePropertyReportButtons = true;
          }
        } else {
          this.notificationService.showWarningMessage("Warning", "No planning report found.");
        }
      });
  }

  private checkPropertyImages(): void {
    this.loading = true;
    this.propertyListingService.apiV1PropertyListingGetPropertyListingByIdGet({ listingId: this.selectedListing?.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Can not get Property Images."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: PropertyListingDto | void) => {
        if (result && result.image) {
          this.filePropertyImageUrl = result.image?.split('?')[0] ?? result.image;
          this.propertyImageFileId = result.cadastreId;
          this.hidePropertyImageButtons = true;
        } else {
          this.loading = true;
          this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: this.selectedListing?.propertyDetail?.cadastreId ?? this.selectedListing?.propertyDetail?.cadastre?.id })
            .pipe(
              catchError((err) =>
                of(this.notificationService.showErrorMessage("Error", "Can not get Property Images."))
              ),
              finalize(() => {
                this.loading = false;
              })
            )
            .subscribe((result: any | void) => {
              if (result)
                this.filePropertyImageUrl = result?.split('?')[0] ?? result;
              this.propertyImageFileId = this.selectedListing?.propertyDetail?.cadastreId ?? this.selectedListing?.propertyDetail?.cadastre?.id;
              this.hidePropertyImageButtons = true;
            });
        }
      });
  }
}
